// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh;
  width: 100%;
}

.vc-button {
  font-size: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: min(30px, 1vw);
  width: 60px !important;
  height: 60px !important;
}
.vc-button > * {
  font-size: 28px !important;
}
.vc-button.active {
  color: #00cc64;
}

.vc-dropdown-button {
  border-radius: 20px;
  border: 1px solid #fff;
  width: 70px;
  display: flex;
  justify-content: center;
  margin-right: min(30px, 1vw);
}
.vc-dropdown-button > .ant-btn {
  font-size: 30px;
  color: #fff;
  display: flex;
  height: 60px !important;
  align-items: center;
  border-width: 0 !important;
  padding: 0;
  margin-right: 5px;
}
.vc-dropdown-button > .ant-btn:hover {
  color: #40a9ff;
}
.vc-dropdown-button > .ant-btn[disabled] {
  background: transparent;
  color: #999;
}
.vc-dropdown-button > .ant-dropdown-trigger {
  width: 20px !important;
  margin-right: 0;
  margin-left: 3px;
}

.vc-dropdown-menu {
  border: 1px solid #747487;
  background: rgba(0, 0, 0, 0.9) !important;
}
.vc-dropdown-menu .ant-dropdown-menu-item {
  padding: 10px 30px;
  color: #ccc;
  position: relative;
}
.vc-dropdown-menu .ant-dropdown-menu-item .anticon-check {
  position: absolute;
  left: 10px;
  top: 15px;
}
.vc-dropdown-menu .ant-dropdown-menu-item:hover {
  color: #40a9ff;
}
.vc-dropdown-menu .ant-dropdown-menu-item-group-title {
  color: #fff;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/components/video-footer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AACA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;AAEF;AADE;EACE,0BAAA;AAGJ;AADE;EACE,cAAA;AAGJ;;AACA;EACE,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;AAEF;AADE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;EACA,iBAAA;AAGJ;AAFI;EACE,cAAA;AAIN;AADE;EACE,uBAAA;EACA,WAAA;AAGJ;AADE;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAGJ;;AAAA;EACE,yBAAA;EACA,yCAAA;AAGF;AAFE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAIJ;AAHI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAKN;AAHI;EACE,cAAA;AAKN;AAFE;EACE,WAAA;EACA,gBAAA;AAIJ","sourcesContent":[".video-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 10vh;\n  width: 100%;\n}\n.vc-button {\n  font-size: 30px;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right:min(30px,1vw);\n  width: 60px !important;\n  height: 60px !important;\n  > *{\n    font-size: 28px !important;\n  }\n  &.active {\n    color: #00cc64;\n  }\n \n}\n.vc-dropdown-button {\n  border-radius: 20px;\n  border: 1px solid #fff;\n  width: 70px;\n  display: flex;\n  justify-content: center;\n  margin-right:min(30px,1vw);\n  > .ant-btn {\n    font-size: 30px;\n    color: #fff;\n    display: flex;\n    height: 60px !important;\n    align-items: center;\n    border-width: 0 !important;\n    padding: 0;\n    margin-right: 5px;\n    &:hover {\n      color: #40a9ff;\n    }\n  }\n  > .ant-btn[disabled]{\n    background: transparent;\n    color: #999;\n  }\n  > .ant-dropdown-trigger {\n    width: 20px !important;\n    margin-right: 0;\n    margin-left: 3px;\n  }\n}\n.vc-dropdown-menu {\n  border: 1px solid #747487;\n  background: rgba(0, 0, 0, 0.9) !important;\n  .ant-dropdown-menu-item {\n    padding: 10px 30px;\n    color: #ccc;\n    position: relative;\n    .anticon-check {\n      position: absolute;\n      left: 10px;\n      top: 15px;\n    }\n    &:hover {\n      color: #40a9ff;\n    }\n  }\n  .ant-dropdown-menu-item-group-title {\n    color: #fff;\n    font-weight: 700;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
